import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { BUSINESS } from "../data/content";

const LINKS = [
  { label: "Services", href: "/#services" },
  { label: "Stickers", href: "/#stickers" },
  { label: "Banners", href: "/#banners" },
  { label: "Process", href: "/#process" },
  { label: "Brand", href: "/brand" },
  { label: "About", href: "/#about" },
  { label: "Start a project", href: "/questionnaire" },
  { label: "Contact", href: "/#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#070708]/85 backdrop-blur-md border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-6 lg:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <img src="/hylyte-hd-logo.png" alt="Hylyte Digital" className="h-7 md:h-8 w-auto" />
        </a>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-muted hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href={BUSINESS.phoneHref}
            data-testid="nav-call-button"
            className="inline-flex items-center gap-2 rounded-full bg-signal px-5 py-2.5 text-sm font-semibold text-white hover:bg-signal-hover transition-colors duration-200 neon-glow"
          >
            <Phone size={15} />
            {BUSINESS.phone}
          </a>
        </div>

        <button
          data-testid="nav-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-[#070708]/95 backdrop-blur-md border-b border-white/10" data-testid="nav-mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-muted hover:text-white transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a
              href={BUSINESS.phoneHref}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-signal px-5 py-3 text-sm font-semibold text-white"
            >
              <Phone size={15} />
              Call {BUSINESS.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
